import React from "react";

const Textarea = ({ name, label, error, ...rest }) => {
  return (
    <div className="form-group" style={{ marginBottom: "0px" }}>
      {label && <label htmlFor={name}>{label}</label>}
      <textarea {...rest} name={name} className="form-control" id={name} />
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Textarea;



// WEBPACK FOOTER //
// ./src/components/Common/textarea.jsx